import { render, staticRenderFns } from "./DatingPreference.vue?vue&type=template&id=fde6929c&scoped=true"
import script from "./DatingPreference.vue?vue&type=script&lang=js"
export * from "./DatingPreference.vue?vue&type=script&lang=js"
import style0 from "./DatingPreference.vue?vue&type=style&index=0&id=fde6929c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fde6929c",
  null
  
)

export default component.exports